import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import { PublicClientApplication } from '@azure/msal-browser';
import { env } from './constants/env';

// Msal Configurations
const config = {
  auth: {
    authority: 'https://login.microsoftonline.com/4ac6b7ee-ca4a-40de-a057-1f654d8bf873',
    clientId: '01bee8c8-e53b-420b-85f2-1594af754098',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/signed-out'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  }
};
 
// Authentication Parameters
const authenticationParameters = {
  scopes: [
    'user.read'
  ]
}
 
// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin 
}
 
export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)
export const msalInstance = new PublicClientApplication(config);

// Check if we're in portal mode - if so, skip all MSAL initialization
const REACT_APP_PORTAL_MODE = env.REACT_APP_PORTAL_MODE;
const isPortalMode = REACT_APP_PORTAL_MODE === "true";

// Only initialize MSAL and handle auto-login in admin mode
if (!isPortalMode) {
  // Initialize MSAL and handle redirect response
  msalInstance.initialize().then(() => {
    console.log('MSAL instance initialized');
    
    // Handle redirect response if we're returning from a login redirect
    return msalInstance.handleRedirectPromise();
  }).then((response) => {
    if (response) {
      console.log('Redirect response handled:', response.account?.username);
      // Set the account as active if we got one from the redirect
      if (response.account) {
        msalInstance.setActiveAccount(response.account);
        console.log('Active account set from redirect:', response.account.username);
      }
    } else {
      console.log('No redirect response to handle');
    }

    // Simple auto-login: only when NOT on the signed-out page and no account present.
    try {
      const pathIsSignedOut = window.location.pathname.includes('/signed-out');
      const active = msalInstance.getActiveAccount();
      const accounts = msalInstance.getAllAccounts();
      // If we already have an account (or we're on the signed out holding page) clear any previous attempt counter.
      if (pathIsSignedOut || active || accounts.length > 0) {
        try { sessionStorage.removeItem('msal_auto_login_attempts'); } catch (_) { /* noop */ }
      }

      if (!pathIsSignedOut && !active && accounts.length === 0) {
        const ATTEMPT_KEY = 'msal_auto_login_attempts';
        const MAX_ATTEMPTS = 2; // Prevent infinite loop if something keeps failing redirect.
        let attempts = 0;
        try {
          const raw = sessionStorage.getItem(ATTEMPT_KEY);
          if (raw) attempts = parseInt(raw, 10) || 0;
        } catch (_) { /* ignore parse/storage issues */ }

        if (attempts >= MAX_ATTEMPTS) {
          console.warn(`Auto login suppressed after ${attempts} attempts. Staying on page.`);
        } else {
          attempts += 1;
          try { sessionStorage.setItem(ATTEMPT_KEY, String(attempts)); } catch (_) { /* ignore */ }
          console.log(`Auto login attempt ${attempts}: redirecting (no account, not on signed-out page).`);
          msalInstance.loginRedirect({ scopes: ['user.read'] });
        }
      }
    } catch (e) {
      console.error('Auto login evaluation error:', e);
    }
  }).catch((error) => {
    console.error('MSAL initialization or redirect handling error:', error);
  });
} else {
  console.log('Portal mode detected - skipping MSAL auto-login initialization');
}

// Export MSAL instance to window object for debugging in development
if (process.env.NODE_ENV === 'development') {
    window.msalInstance = msalInstance;
}